'use client';

import { Container } from 'react-bootstrap';
import type { PortableTextBlock } from 'next-sanity';

import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import type { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import './PricingCallout.scss';

type LandingPageData = Extract<
  NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>,
  { _type: 'landingPage' }
>;

interface PricingCalloutProps {
  data: NonNullable<LandingPageData['pricingCallout']>;
}

export default function PricingCallout({ data }: PricingCalloutProps) {
  const { headline, freePlanContent, paidPlanContent, backgroundColor } = data;

  return (
    <section
      className="rlp-pricing-callout"
      style={
        backgroundColor?.value ? { backgroundColor: backgroundColor.value } : {}
      }
    >
      <Container>
        <div className="rlp-pricing-content">
          {headline && (
            <div className="rlp-section-headline">
              <LandingPortableText value={headline as PortableTextBlock[]} />
            </div>
          )}
          <div className="rlp-pricing-plans">
            {freePlanContent && (
              <div className="rlp-pricing-plan rlp-pricing-plan--free">
                <LandingPortableText
                  value={freePlanContent as PortableTextBlock[]}
                />
              </div>
            )}
            {paidPlanContent && (
              <div className="rlp-pricing-plan rlp-pricing-plan--paid">
                <LandingPortableText
                  value={paidPlanContent as PortableTextBlock[]}
                />
              </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
}
